import * as React from "react";

import { cn } from "frontend-components/lib/utils";

function Textarea({ className, ...props }: React.ComponentProps<"textarea">) {
    return (
        <textarea
            data-slot="textarea"
            className={cn(
                "font-body text-text-primary placeholder:text-text-muted border-border-input hover:border-border-input-hover focus-visible:border-border-focus aria-invalid:border-chameleon-pink field-sizing-content min-h-[120px] w-full resize-y rounded-none border bg-white px-3 py-2.5 text-base font-normal outline-none transition-[border-color] disabled:cursor-not-allowed disabled:opacity-50",
                className,
            )}
            {...props}
        />
    );
}

export { Textarea };
